/**
 * Lit Context definitions for UI dependency injection
 */

import { createContext } from '@lit/context';
import type { GameAPIType } from './GameAPI';

/** Context for GameAPI facade */
export const gameApiContext = createContext<GameAPIType>('game-api');
